export default __webpack_public_path__ + "static/cloth.header.mobile-df0ea4641480995d43a7fac0cb1a9372.jpg";